module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab103-7787fa89b295a3308e1881bc00589edf.jpg";